import axios from 'axios';
import i18n from '../i18n';
import {getSportBaseUrl} from './sportFeedApi';

/**
 * Le chiamate della Home (la vetrina).
 *
 * Una sola, per ora: le prossime partite. Il resto della vetrina - benvenuto,
 * banner, live, casino' - non ha ancora niente da chiamare, e sta scritto
 * nella pagina cosa manca e dove va fatto.
 */

/**
 * Le prossime partite di tutti gli sport, dal catalogo:
 * GET /private/catalog/feed/prossime?limite=N
 *
 * La forma di ogni partita e' la stessa delle altre rotte del feed, piu'
 * `sportName`: cosi' la quota che si mette in schedina da qui e' identica a
 * quella della pagina Sport.
 *
 * Non ripiega su niente: se il catalogo non risponde, la vetrina lo dice
 * con codice e dettaglio, invece di mostrare partite inventate.
 */
export function prossimePartite(limite) {
  const quante = Number(limite) > 0 ? Number(limite) : 12;
  return axios
      .get(`${getSportBaseUrl()}/private/catalog/feed/prossime`, {
        params: {limite: quante},
        timeout: 8000,
      })
      .then((res) => (Array.isArray(res.data) ? res.data : []));
}

/**
 * L'errore scritto come lo vuole il sito: codice E dettaglio, mai il numero
 * da solo. "503 - Service Unavailable" dice dove guardare; "errore" no.
 * Le frasi passano dal dizionario (i18n.t): qui non c'e' React, quindi si
 * chiama i18n direttamente. Il dettaglio che arriva dal servizio resta
 * com'e'.
 */
export function descriviErrore(e) {
  const t = (chiave, valori) => i18n.t(chiave, valori);
  if (!e) return t('Errore sconosciuto');
  if (e.code === 'ECONNABORTED') return t('Nessuna risposta dal catalogo (tempo scaduto)');
  if (e.response) {
    const corpo = e.response.data || {};
    const dettaglio = corpo.message || corpo.error || e.response.statusText || '';
    return dettaglio
      ? t('Errore {{codice}} - {{dettaglio}}', {codice: e.response.status, dettaglio})
      : t('Errore {{codice}}', {codice: e.response.status});
  }
  if (e.request) return t('Catalogo non raggiungibile (nessuna risposta dalla rete)');
  return String(e.message || e);
}
